import classnames from 'classnames/bind'
import Icon from '@/assets/icons'
import { TicketsData } from '@/hooks/usePromotion'
import { useTranslation } from 'next-i18next'

interface SelectedItemProps {
  selected: TicketsData | undefined
  isOpen: boolean
}
// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)
const SelectedItem = ({ selected, isOpen }: SelectedItemProps) => {
  const { t } = useTranslation('')
  return (
    <div className={cx('selected-option')}>
      <div className={cx('selected-option-section')}>
        <div className={cx('selected-option-text')}>{selected?.couponName || t('Product_Detail_Check_Coupon')}</div>
      </div>
      <div className={cx('selected-option-toggle')}>
        <div className={cx('selected-option-toggle-icon', isOpen ? 'rotate' : '')}>
          <Icon.ArrowRight />
        </div>
      </div>
    </div>
  )
}

export default SelectedItem
